import kformUtils from "../../utils/kform-utils";

export default /* @ngInject */ (/** @type {any} */ $scope) => {
	if ($scope.options?.building) {
		return;
	}

	/** @type {any} */
	const boolean = {
		[$scope.component?.trueValue ?? true]: true,
		[$scope.component?.falseValue ?? false]: false,
	};

	const defaultValue = $scope.component?.defaultValue === undefined
		? false : boolean[$scope.component.defaultValue];

	// FA-850 - Ensure the checked value is always a boolean object when loaded, then unbind the watch.
	if ($scope.data && $scope.component?.inputType === 'checkbox') {
		// FOR-440 - Only use the default value if the data isn't defined.
		// On the first load, attempt to set the default value.
		$scope.data[$scope.component.key] = Object.prototype.hasOwnProperty.call(
			$scope.data, $scope.component.key,
		) && Object.prototype.hasOwnProperty.call(
			boolean, $scope.data[$scope.component.key],
		)
			? boolean[$scope.data[$scope.component.key]]
			: defaultValue;

		$scope.$watch(`data.${$scope.component.key}`, () => {
			if (!$scope.data || !$scope.component.key) {
				return;
			}

			// If the component is required, and its current value is false, delete the entry.
			if (
				$scope.component.validate?.card?.isRequired()
				&& boolean[$scope.data[$scope.component.key]] === false
			) {
				delete $scope.data[$scope.component.key];
			}
		});
	}

	$scope.topOrLeftOptionLabel = kformUtils.labelPositionWrapper(kformUtils.topOrLeftOptionLabel);
	$scope.getOptionLabelStyles = kformUtils.labelPositionWrapper(kformUtils.getOptionLabelStyles);
	$scope.getOptionInputStyles = kformUtils.labelPositionWrapper(kformUtils.getOptionInputStyles);

	$scope.changeValue = () => {
		if (typeof $scope.component?.event.onChange === 'string') {
			const custom = ''.concat($scope.component.event.onChange, '; ');
			kformUtils.evaluate(custom, {
				data: $scope.data,
				form: $scope.form,
			});
		}
	};
};
